module.exports = __webpack_public_path__ + "img/APS_scenario.1be0de83.svg";